export const environment = {
  production: false,
  //  serverIP:'https://faysalfunds-api.lfdanalytics.com/',
  // serverIP: 'https://faysalfunds-devapi.lfdanalytics.com/',
  serverIP : 'https://faysalfunds-devapiv2.lfdanalytics.com/'
};